import { MyTooltip } from "../common/MyTooltip";

type LinkNotFoundCollectionTooltipProps = {
  status: string;
};

export const LinkNotFoundCollectionTooltip = ({status}: LinkNotFoundCollectionTooltipProps) => {
  let message =
    `The link returned an ${status} error and does not appear to be valid or we do not have access`;

  return (
    <MyTooltip
      title={
        <>
          <span
            style={{
              color: "var(--text-color-primary",
            }}>
            {message}
          </span>
        </>
      }>
      {/* <img
        src={"/icons/404.svg"}
        onClick={() => {}}
        // style={{
        //   outline: fu.selected
        //     ? "2px solid var(--unseen-badge-color)"
        //     : "1px solid var(--container-border-color)",
        // }}
        // className="link-not-found-exclaim"
        alt=""
      /> */}
      <span style={{color: "red", fontWeight: 600}}>{status}</span>
    </MyTooltip>
  );
};
